import { Alert, Box, Button, Divider, Modal, Snackbar, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LOGIN_USER_action } from '../store/actions/userAction';
import store from '../store';
import { clamp } from 'date-fns';
import storeToken from '../storeToken';
import { TOKEN_action } from '../store/actions/tokenAction';
// import Cookies from 'js-cookie';
import CryptoJS from "crypto-js";
import LockIcon from '@mui/icons-material/Lock';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EmailIcon from '@mui/icons-material/Email';
import Slide from '@mui/material/Slide';
import { requestPermissions, getFCMToken } from "../services/firebase";

const mapStateToProps = (state) => {
  return {
    user: state.userReducer,
    pageParameters: state.pageReducer
  };
}


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AlertDialogSlide() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen}>
        Slide in alert dialog
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Use Google's location service?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={handleClose}>Agree</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

// const modalStyle = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: 400,
//   bgcolor: 'background.paper',
//   border: '2px solid #000',
//   boxShadow: 24,
//   p: 4,
// };

const Login = (props) => {
  let [actualVersion, setActualVersion] = useState(75);
  let [actualVersion2, setActualVersion2] = useState(0);
  let [openUpdateSnackbar, setOpenUpdateSnackbar] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive
  let [msgError, setMsgError] = useState("")
  const [loading, setLoading] = useState(false); // Estado para la pantalla de carga
  const location = useLocation();
  let [dataFromURL, setDataFromURL] = useState('');

  const [openModal, setOpenModal] = React.useState(false);
  const [openModalDetails, setOpenModalDetails] = React.useState(false);

  let [publicKey, setPublicKey] = useState('');
  let statePublicKey = '';
  let [privateKey, setPrivateKey] = useState('');
  let statePrivateKey = '';
  let [nameState, setNameState] = useState(false);
  let [passwordState, setPasswordState] = useState(false);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [showAlert, setShowAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState('');
  let [FCMtoken, setFCMtoken] = useState('');

  const navigate = useNavigate();

  const nameValidation = (event) => {
    setEmail(event.target.value)
  }

  const passwordValidation = (event) => {
    setPassword(event.target.value)
  }
  // async function getFCMToken() {
  //   try {
  //     // Solicita permisos
  //     await FirebaseMessaging.requestPermissions();

  //     // Obtener el token FCM
  //     setFCMtoken(await FirebaseMessaging.getToken());
  //     console.log("FCM Token:", FCMtoken);
  //   } catch (error) {
  //     console.error("Error al obtener el token FCM:", error);
  //   }
  // }

  async function getUserInfo() {

    const token = localStorage.getItem('jwt_token');

    const data = {
      // "UserID": 5051, // Modo desarrollo
      "UserID": 1080, // Modo produccion
    }
    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const headers = 'content-type: application/json; charset=utf-8'

    await axios.post('https://socializeapi.azurewebsites.net/api/GetUser', { data: data_encripted }, {
      headers
    })
      .then(response => {
        // Check if both values are valid numbers before comparing
        const currentVersion = Number(actualVersion);
        const serverVersion = Number(response.data.telephone);

        if (!isNaN(currentVersion) && !isNaN(serverVersion) && currentVersion !== serverVersion) {
          setActualVersion2(response.data.telephone);
          console.log("version diferente");
          // setShowModalActualizacionPendiente(true);
          setOpenUpdateSnackbar(true); // Mostrar el snackbar
        }
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }

  async function LoginAction() {
    let password_local;
    if (email.trim() === '' || password.trim() === '') {
      setShowAlert(true);
      setAlertDetails('Por favor, completa todos los campos para poder iniciar sesión.')
      return;
      // } else if(email.trim() !== props.user.email) {
      //   setShowAlert(true);
      //   setAlertDetails('El mail ingresado es incorrecto.')
      // } else if(password.trim() !== props.user.pass) {
      //   setShowAlert(true);
      //   setAlertDetails('La contraseña ingresada es incorrecta.')
    } else {
      setLoading(true); // Mostrar pantalla de carga
      try {


        const headers = 'content-type: application/json; charset=utf-8'

        // const encryptionKey = "YfshOureTriyngt0h4$MiYwAR3aJErkP1e%s3D0n7";
        const encryptionKey = "EsteEsUnEjemploDeClaveDe32Caracteres!";
        let datos = {
          password: password,
          email: email
        }

        const password_local = CryptoJS.AES.encrypt(password, encryptionKey).toString();

        // await obtenerVAPID()
        // await subscribeToPushNotifications(1);

        await axios.post(`https://socializeapi.azurewebsites.net/api/LoginUser`, { email, password: password_local }, { headers })
          .then(async response => {
            if (response.data !== null) {
              if (response.data == "El mail ingresado es incorrecto.") {
                setMsgError("El mail ingresado es incorrecto.")
                return;
              } else if (response.data == "La contraseña es incorrecta.") {
                setMsgError("La contraseña es incorrecta.")
                return;
              } else {

                //-----------------------------
                // var imageUrl = base64ToUrl(response.data.userDto.avatar)
                var imageUrl = response.data.userDto.avatar

                // response.data.userDto.avatar = imageUrl
                // store.dispatch(LOGIN_USER_action([props.user.name, email, props.user.phone, password]))
                store.dispatch(LOGIN_USER_action(response.data.userDto))
                store.dispatch(TOKEN_action(response.data.result))
                localStorage.setItem('jwt_token', response.data.result)

                localStorage.setItem('userID', response.data.userDto.userID) // quitar en el futuro

                localStorage.setItem('userData', JSON.stringify(response.data.userDto));



                let token = localStorage.getItem('jwt_token');


                navigate('/', { state: { token } }); // Pasas el token en 'state'

                // Cookies.set('authToken', token)


              }

            } else {
              setShowAlert(true);
              setAlertDetails('La cuenta a la que intenta ingresar no existe.')
            }

          })
          .catch(error => {
            console.log(`Error obteniendo datos: ${error}`);
          });
      } catch (error) {
        console.log(`Error obteniendo datos: ${error}`);
      } finally {
        if (localStorage.getItem('eventID') && localStorage.getItem('eventID').toString() !== "" && msgError == "") {
          InvitarAutoAEvento()
        }
        setLoading(false); // Ocultar pantalla de carga

      }

    }

    setShowAlert(false);
    // Aquí puedes agregar la lógica para validar y enviar los datos del formulario
  }



  function base64ToUrl(base64String) {
    // Determinar el tipo de la imagen (PNG o JPEG)
    const mimeType = base64String.charAt(0) === '/' ? 'image/jpeg' : 'image/png';

    // Decodificar Base64 a un array de bytes
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Crear un Blob con el tipo MIME detectado
    const blob = new Blob([byteArray], { type: mimeType });

    // Crear y devolver la URL del objeto
    return URL.createObjectURL(blob);
  }

  async function InvitarAutoAEvento() {
    const headers = 'content-type: application/json; charset=utf-8'

    const token = localStorage.getItem('jwt_token');
    var eventID = localStorage.getItem('eventID');
    var userID = localStorage.getItem('userID');

    const data = {
      "eventID": eventID,
      "userID": userID,
      "loginWithKey": "true"
    }

    console.log("token")
    console.log(token)

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    await axios.put(`https://socializeapi.azurewebsites.net/api/UpdateEvent`, { data: data_encripted }, {
      // withCredentials: true,
      headers
    })
      .then(response => {
        localStorage.removeItem('eventID');
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });


  }

  async function obtenerVAPID() {
    const headers = 'content-type: application/json; charset=utf-8'

    await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
      .then(response => {
        if (response.data !== null) {
          setPublicKey(response.data.value.keys.publicKey)
          statePublicKey = response.data.value.keys.publicKey
          setPrivateKey(response.data.value.keys.privateKey)
          statePrivateKey = response.data.value.keys.privateKey
        }

      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }



  async function subscribeToPushNotifications(userId) {
    const userAgent = navigator.userAgent;
    console.log('Service Worker supported:', 'serviceWorker' in navigator);
    console.log('Push Manager supported:', 'PushManager' in window);

    const registration = await navigator.serviceWorker.register('/service-worker.js');

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.error('Permission for notifications was denied.');
      return;
    }


    // Verificar si ya hay una suscripción existente
    let subscription = await registration.pushManager.getSubscription();


    console.log("subscription");
    console.log(subscription);



    // Si ya hay una suscripción, desuscribirse
    if (subscription) {
      await subscription.unsubscribe();
      console.log('Successfully unsubscribed from the existing subscription.');
    }



    // try {
    //   const addsubscription = await registration.pushManager.subscribe({
    //     userVisibleOnly: true,
    //     applicationServerKey: urlBase64ToUint8Array(statePublicKey)
    //   });

    //   console.log("addsubscription")
    //   console.log(addsubscription)
    //   await axios.post(`https://socializeapi.azurewebsites.net/api/register-push?userId=${userId}`, {
    //     endpoint: addsubscription.endpoint,
    //     keys: {
    //       p256dh: addsubscription.keys.p256dh,
    //       auth: addsubscription.keys.auth
    //     }
    //   });
    // } catch (error) {
    //   console.error('Failed to subscribe:', error);
    // }
    validateApplicationServerKey(statePublicKey)
    try {
      const addsubscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(statePublicKey)
      });

      console.log("addsubscription object:", JSON.stringify(addsubscription));


      // Validar que `keys` esté definido antes de usarlo
      if (!addsubscription.getKey('p256dh') || !addsubscription.getKey('auth')) {
        throw new Error("Keys are undefined in the subscription object");
      }

      const data = {
        Endpoint: addsubscription.endpoint,
        P256dh: addsubscription.getKey('p256dh'),
        Auth: addsubscription.getKey('auth'),
        UserId: userId
      }

      const jsonData = JSON.stringify(data);
      const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

      console.log("userAgent")
      console.log(userAgent)
      // Enviar la suscripción al backend
      await axios.post(`https://socializeapi.azurewebsites.net/api/register-push?userId=${userId}`, {
        Endpoint: addsubscription.endpoint,
        // Keys: {
        //   p256dh: addsubscription.getKey('p256dh'),
        //   auth: addsubscription.getKey('auth')
        // }
        Keys: {
          p256dh: btoa(String.fromCharCode(...new Uint8Array(addsubscription.getKey('p256dh')))),
          auth: btoa(String.fromCharCode(...new Uint8Array(addsubscription.getKey('auth'))))
        },
        PublicKey: statePublicKey,
        PrivateKey: statePrivateKey,
        UserAgent: userAgent

      });
    } catch (error) {
      console.error('Failed to subscribe:', error.message || error);
    }



    //   await axios.post(`https://socializeapi.azurewebsites.net/api/register-push?userId=${userId}`, {
    //     endpoint: addsubscription.endpoint,
    //     keys: {
    //       p256dh: addsubscription.getKey('p256dh'),
    //       auth: addsubscription.getKey('auth')
    //     }
    //   });
    // } catch (error) {
    //   console.error('Failed to subscribe:', error.message || error);
    // }



  }





  const requestNotificationPermission = async () => {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.error('Permission for notifications was denied.');
      return;
    }
    console.log('Permission for notifications granted.');
  };

  // Convertir la clave VAPID de Base64 a Uint8Array
  // function urlBase64ToUint8Array(base64String) {
  //   const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  //   const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  //   const rawData = window.atob(base64);
  //   const outputArray = new Uint8Array(rawData.length);

  //   for (let i = 0; i < rawData.length; i++) {
  //     outputArray[i] = rawData.charCodeAt(i);
  //   }

  //   return outputArray;
  // }

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
  }

  async function validateApplicationServerKey(applicationServerKey) {
    try {
      const key = await crypto.subtle.importKey(
        'raw',
        urlBase64ToUint8Array(applicationServerKey),
        { name: 'ECDSA', namedCurve: 'P-256' },
        true,
        []
      );
      console.log('La clave es válida:', key);
      return true;
    } catch (error) {
      console.error('Clave no válida:', error);
      return false;
    }
  }



  function forgottenPass() {
    try {
      setOpenModal(false)
      setOpenModalDetails(true)
      const headers = { 'Content-Type': 'application/json; charset=utf-8' };
      const token = localStorage.getItem('jwt_token');
      const encryptionKey = "EsteEsUnEjemploDeClaveDe32Caracteres!";
      let datos = {
        password: password,
        email: email
      }

      const password_local = CryptoJS.AES.encrypt(password, encryptionKey).toString();

      axios.post(`https://socializeapi.azurewebsites.net/api/RecoverPassword`, { Email: email }, { headers })
        .then(response => {
          if (response.data !== null) {
            // store.dispatch(LOGIN_USER_action([props.user.name, email, props.user.phone, password]))
          } else {
            setShowAlert(true);
            setAlertDetails('La cuenta a la que intenta ingresar no existe.')
          }

        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
        });
    } catch (error) {

    }
  }


  function decryptData(encryptedText) {

    // Define la misma clave que usaste en el backend
    const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

    // Decodifica el texto encriptado de base64
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

    // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
    const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
    const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

    // Deriva la clave usando SHA256
    const hashedKey = CryptoJS.SHA256(key);

    // Desencripta el contenido
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedContent },
      hashedKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    // Convierte el resultado a texto legible
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  const getDataFromURL = () => {
    const queryParams = new URLSearchParams(location.search);
    const encryptedValue = queryParams.get('data');

    console.log("valor de getDataFromURL")
    console.log(encryptedValue)

    if (encryptedValue != "" && encryptedValue != null & encryptedValue != undefined) {

      return encryptedValue;
    } else {
      return "";
    }

  };

  async function detectDeviceType() {
    const userAgent = navigator.userAgent;
    console.log("userAgent")
    console.log(userAgent)
    if (/android/i.test(userAgent)) {
      return "android";
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "ios";
    } else {
      return "web";
    }
  };




  useEffect(() => {

    const validateToken = async () => {
      const dataFromURL = getDataFromURL();

      if (dataFromURL !== "") {
        // console.log("dataFromURL")
        // console.log(dataFromURL)
        // let decripted_response = decryptData(dataFromURL);

        // setDataFromURL(dataFromURL);





        // const secretKey = "EsteEsUnEjemploDeClaveDe32Caracteres!"; // Clave compartida entre origen y destino

        // // Desencriptar el valor
        // const decryptedValue = CryptoJS.AES.decrypt(dataFromURL, secretKey).toString(CryptoJS.enc.Utf8);

        // console.log("decryptedValue login")
        // console.log(decryptedValue)
        setDataFromURL("decryptedValue")

      }
    };

    validateToken();
  }, []);

  useEffect(() => {
    if (navigator.userAgent.includes("Android")) {

      getUserInfo();
  }


    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  async function loginAsGuest() {
    var invitedUser = {
      avatar: "",
      email: "",
      nameUser: "",
      pass: "",
      registerDate: "",
      telephone: "",
      userID: 0
    }
    localStorage.setItem('jwt_token', "")

    localStorage.setItem('userData', JSON.stringify(invitedUser));
    store.dispatch(LOGIN_USER_action({}))
    navigate('/')
  }


  // Estilos en línea como objetos de JavaScript
  const styles = {
    loadingScreen: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    loadingModal: {
      backgroundColor: 'white',
      padding: '20px 30px',
      borderRadius: '8px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
      textAlign: 'center',
    },
    loadingSpinner: {
      margin: '20px auto',
      width: '40px',
      height: '40px',
      border: '4px solid transparent',
      borderTop: '4px solid #3498db',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
  };

  return (
    <div style={{ flexGrow: 1 }}>
      <div style={{
        display: 'flex',
        height: '100vh',
      }}>

        {loading && (
          <div className="loading-screen">
            <div className="loading-modal">
              <p>Iniciando sesión, por favor espere...</p>
              <div className="loading-spinner"></div>
            </div>
          </div>
        )}


        {/* Bienvenida */}
        <div style={{
          backgroundColor: '#009688',
          justifyContent: 'center',
          alignItems: 'center',
          display: (isLargeScreen ? 'flex' : 'none'),
          flexDirection: 'column',
          width: '40%',
        }}>
          <div style={{ flexGrow: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <p style={{
              color: '#b2dfdb',
              fontWeight: '500',
              // fontSize: 56,
              fontSize: 72,
            }}>
              Socialize
            </p>
          </div>
          <div style={{ flexGrow: 4, textAlign: 'center' }}>

            <p style={{
              color: 'white',
              fontWeight: '500',
              fontSize: 48,
            }}>Bienvenido de vuelta!</p>
            <p style={{
              color: 'white',
              fontSize: 24,
              marginTop: 16,
              marginInline: 64,
              textAlign: 'center',
              fontWeight: '300'
            }}>Ingresa para conocer todos los eventos disponibles en tu ciudad!</p>
          </div>
        </div>

        {/* Formulario */}
        <div style={{
          flexGrow: 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '60%',
          minWidth: (isLargeScreen && 500),
        }}>
          <p style={{
            // color: '#009688',
            color: (showAlert ? '#DC3545' : '#0D6EFD'),
            fontWeight: '500',
            fontSize: `clamp(32px, 4vw, 64px)`,
            marginBottom: 64
          }}>Iniciar Sesión</p>

          {/* Formulario */}
          <div style={{ width: (isLargeScreen ? '50%' : '80%'), display: 'flex', flexDirection: 'column' }}>
            <TextField
              fullWidth
              style={{
                marginTop: 16,
                marginBottom: 16
              }}
              label="Email"
              variant='outlined'
              type="email"
              value={email}
              onChange={nameValidation}
              required
              InputProps={{
                startAdornment: (
                  <EmailIcon sx={{
                    color: 'action.active',
                    mr: 1,
                    my: 0.5
                  }} />
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: 'primary.main',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'primary.main',
                  },
                },
                '& .MuiInputLabel-root': {
                  '&.Mui-focused': {
                    color: 'primary.main',
                  },
                },
                borderRadius: 2,
                backgroundColor: 'background.paper',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            />
            <TextField
              style={{
                marginTop: 16,
                width: '100%'
              }}
              label="Contraseña"
              variant="outlined"
              type="password"
              value={password}
              onChange={passwordValidation}
              required
              InputProps={{
                startAdornment: (
                  <LockIcon sx={{
                    color: 'action.active',
                    mr: 1,
                    my: 0.5
                  }} />
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: 'primary.main',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'primary.main',
                    borderWidth: '2px',
                  },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'primary.main',
                },
                borderRadius: 2,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            />
            {msgError && (
              <Typography fontSize={12} marginBottom={2} color={'red'}>{msgError}</Typography>
            )}

            <Button variant="text" color={showAlert ? 'error' : 'success'} onClick={() => { setOpenModal(true) }} style={{ marginBottom: 16 }}>
              Olvidaste tu contraseña?
            </Button>

            <div style={{ display: 'flex' }}>
              <Button variant="contained" color={showAlert ? 'error' : 'primary'} onClick={LoginAction} style={{ width: '49%', marginBottom: 8 }}>
                Iniciar Sesion
              </Button>

              <Button variant="outlined" color={showAlert ? 'error' : 'warning'} onClick={loginAsGuest} style={{ width: '49%', marginBottom: 8, marginLeft: 'auto' }}>
                Ingresar sin cuenta
              </Button>
            </div>
            <p style={{ color: 'gray', marginInline: 'auto', marginBottom: 16 }}>No tienes una cuenta? <Link to={'/registro'}>Registrate!</Link></p>

            {showAlert && (
              <Alert severity="warning">
                {alertDetails}
              </Alert>
            )}
          </div>
          <a style={{ color: 'grey', fontSize: 12 }} href='https://hisocialize.netlify.app/terms&conditions'>Términos y Condiciones</a>
        </div>
      </div>

      <Modal
        open={openModal}
        onClose={() => { setOpenModal(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '0.5em'
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Recupera tu cuenta!
          </Typography>
          <div>
            <TextField
              style={{
                marginTop: 16, width: (isLargeScreen ? 400 : 300)
              }}
              label="Email"
              variant='standard'
              type="email"
              value={email}
              onChange={nameValidation}
              required
            />
          </div>

          <Button variant="contained" color='success' onClick={forgottenPass} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300), marginBottom: 16 }}>
            Confirmar Email
          </Button>
        </Box>
      </Modal>


      <Modal
        open={openModalDetails}
        onClose={() => { setOpenModalDetails(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '0.5em'
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Te hemos enviado un correo con un link para renovar tu contraseña al mail que ingresaste, si no lo encuentras verifica en la sección de Spam.
          </Typography>

          <Button variant="contained" color='success' onClick={() => { setOpenModalDetails(false) }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300), marginBottom: 16 }}>
            OK
          </Button>
        </Box>
      </Modal>


      <Snackbar
                open={openUpdateSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenUpdateSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    onClose={() => setOpenUpdateSnackbar(false)} 
                    severity="info" 
                    sx={{ width: '100%' }}
                >
                    ¡Hay una nueva actualización disponible!
                </Alert>
            </Snackbar>


    </div>
  )
}



export default connect(mapStateToProps)(Login);

// import React, { useState } from 'react';
// import { TextField, Button, Alert } from '@mui/material';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showAlert, setShowAlert] = useState(false);

//   const handleEmailChange = (event) => {
//     setEmail(event.target.value);
//   };

//   const handlePasswordChange = (event) => {
//     setPassword(event.target.value);
//   };

//   const handleSubmit = () => {
//     if (email.trim() === '' || password.trim() === '') {
//       setShowAlert(true);
//       return;
//     }

//     setShowAlert(false);
//     // Aquí puedes agregar la lógica para validar y enviar los datos del formulario
//   };

//   return (
//     <div>
//       <TextField
//         label="Email"
//         variant="outlined"
//         type="email"
//         value={email}
//         onChange={handleEmailChange}
//         required
//       />
//       <TextField
//         label="Contraseña"
//         variant="outlined"
//         type="password"
//         value={password}
//         onChange={handlePasswordChange}
//         required
//       />
//       <Button variant="contained" color="primary" onClick={handleSubmit}>
//         Verificar
//       </Button>
//       {showAlert && (
//         <Alert severity="warning">
//           Por favor, completa todos los campos antes de enviar.
//         </Alert>
//       )}
//     </div>
//   );
// };

// export default Login;